import '../globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        if ($.prototype.slick) {
            $('.slider__items').slick({
                prevArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-prev"><span class="ai ai-menu-left"></span></span>',
                nextArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-next"><span class="ai ai-menu-right"></span></span>',
            });

            $(window).on('buy-data-loaded-all', initProductTeaser);

            function initProductTeaser() {

                // ProductTeaser Slider
                if ($('.product-teaser-slider.slick:not(.slick-initialized)').length > 0) {
                    $('.product-teaser-slider.slick:not(.slick-initialized)').each(function () {
                        let responsive = [];

                        if ($(this).data('slidecountxxl') && $(this).data('slidecountxxl') !== -1) {
                            responsive.push({
                                breakpoint: 1399,
                                settings: {
                                    slidesToShow: $(this).data('slidecountxxl'),
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            });
                        }

                        if ($(this).data('slidecountxl') && $(this).data('slidecountxl') !== -1) {
                            responsive.push({
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: $(this).data('slidecountxl'),
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            });
                        }

                        if ($(this).data('slidecountlg') && $(this).data('slidecountlg') !== -1) {
                            responsive.push({
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: $(this).data('slidecountlg'),
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            });
                        }

                        if ($(this).data('slidecountmd') && $(this).data('slidecountmd') !== -1) {
                            responsive.push({
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: $(this).data('slidecountmd'),
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            });
                        }

                        if ($(this).data('slidecountsm') && $(this).data('slidecountsm') !== -1) {
                            responsive.push({
                                breakpoint: 575,
                                settings: {
                                    slidesToShow: $(this).data('slidecountsm'),
                                    slidesToScroll: 1,
                                    infinite: true,
                                },
                            });
                        }

                        const options = {
                            slidesToShow: $(this).data('slidecountxs'),
                            slidesToScroll: 1,
                            dots: false,
                            infinite: true,
                            mobileFirst: true,
                            responsive: responsive,
                            prevArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-prev"><span class="ai ai-menu-left"></span></span>',
                            nextArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-next"><span class="ai ai-menu-right"></span></span>',
                        };

                        $(this).slick(options);

                        $(this).on('click', 'button.bootstrap-touchspin-up', function () {
                            const input = $(this).closest('.bootstrap-touchspin').find('input.quantity-input');
                            const curVal = parseInt($(input).val());

                            $(input).val(curVal < 999 ? (curVal + 1) : 999);
                            $('.shopping-button-async').shoppingButton();
                        });

                        $(this).on('click', 'button.bootstrap-touchspin-down', function () {
                            const input = $(this).closest('.bootstrap-touchspin').find('input.quantity-input');
                            const curVal = parseInt($(input).val());

                            $(input).val(curVal > 1 ? (curVal - 1) : 1);
                            $('.shopping-button-async').shoppingButton();
                        });

                        $(this).on('click', '.add-to-cart', (e) => {
                            const button = e.target.closest('.add-to-cart');

                            if (button) {
                                const customEvent = new CustomEvent('plandent.productSlider.addToCart', {
                                    detail: {
                                        button: e.target.closest('.add-to-cart'),
                                    },
                                    bubbles: true,
                                });

                                button.dispatchEvent(customEvent);
                            }
                        });
                    });
                }
            }
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
